<template>
  <div class="slider-wrapper" ref="slider_wrapper">
    <ul class="slider-tabs" v-if="tabsActive && this.$slots.default[slideNum].data.attrs.title" ref="slider_tabs">
      <template v-for="(slide, index) in this.$slots.default">
        <li :class="{ active: slideNum == index }" :key="'slide_' + index" @click="tabClick(index)" :style="'width: calc(100% / ' + totalTabs() + ');'" v-if="!slide.data.attrs.tabHidden && slide.data.attrs.title">
          <div class="tab-inner">
            <icon :icon="slide.data.attrs.icon" size="2x" v-if="slide.data.attrs.icon"></icon>
            <div class="tab-inner-title">
              <div class="title" v-if="slide.data.attrs.title">
                <Localize :text="slide.data.attrs.title" />
              </div>
              <div class="sub" v-if="slide.data.attrs.subtitle">
                <Localize :text="slide.data.attrs.subtitle" />
              </div>
            </div>
          </div>
        </li>
      </template>
    </ul>
    <div class="slider" :class="{ 'more-padding': morePadding, 'is-form': isFormData }" :style="'width: ' + totalSlides * 100 + '%;' + 'left: ' + (0 - slideNum * 100) + '%;'" ref="slider">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Localize from '@/components/Localize.vue'

export default {
  name: 'Carousel',
  components: {
    Localize
  },
  props: {
    startSlide: {
      type: Number,
      default: 0
    },
    isFormData: {
      type: Boolean,
      default: false
    },
    disableFooter: {
      type: Boolean,
      default: false
    },
    tabsActive: {
      type: Boolean,
      default: false
    },
    skipFirstTab: {
      type: Boolean,
      default: false
    },
    morePadding: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      localSlideNum: 0
    }
  },
  computed: {
    slideNum: function() {
      if (this.isFormData)
        return this.$store.getters.getActivePageIndex

      return this.localSlideNum
    },
    totalSlides: function() {
      return this.$slots.default.length
    }
  },
  methods: {
    goTo: function(newSlideNum) {
      if (newSlideNum < this.totalSlides && newSlideNum >= 0)
        this.localSlideNum = newSlideNum
    },
    next: function() {
      if (this.localSlideNum + 1 < this.totalSlides) this.localSlideNum++
    },
    prev: function() {
      if (this.localSlideNum - 1 >= 0) this.localSlideNum--
    },
    previous: function() {
      this.prev()
    },
    tabClick: function(index) {
      this.goTo(index)
    },
    totalTabs: function() {
      let total_slides = 0
      for (let i = 0; i < this.$slots.default.length; i++) {
        const slide = this.$slots.default[i]
        if (!slide.data.attrs.tabHidden && slide.data.attrs.title)
          total_slides++
      }
      return total_slides
    },
    updateMainCardHeight: function() {
      var vm = this

      // Make sure all content has rendered before calculating client height
      vm.$nextTick(function () {
        if (typeof vm.$refs['slider'] !== 'undefined') {
          const sliderTabHeight = vm.$refs['slider_tabs']
            ? vm.$refs['slider_tabs'].clientHeight
            : 0
          let newHeight =
            vm.$refs['slider'].clientHeight + sliderTabHeight + 'px'
          vm.$refs['slider_wrapper'].style.height = newHeight
        }
      })
    }
  },
  updated: function() {
    this.updateMainCardHeight()
  },
  created: function() {
    if (this.startSlide !== 0) this.localSlideNum = this.startSlide
    this.$root.$on('slider:update', this.updateMainCardHeight)
    window.addEventListener('resize', this.updateMainCardHeight)
  },
  destroyed: function() {
    window.removeEventListener('resize', this.updateMainCardHeight)
  },
  mounted: function() {
    const $this = this
    this.updateMainCardHeight()
  }
}
</script>

<style scoped lang="scss">
.slider-wrapper {
}
</style>
